import { MouseEvent } from 'react';
import clsx from 'clsx';

import { OvalButton } from '../oval-button';

import styles from './styles.module.scss';

type Props = {
  text: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  classNames?: string;
  ariaLabel?: string;
};

export const NextButton = ({ text, onClick, classNames, ariaLabel }: Props) => (
  <OvalButton
    classNames={clsx(styles.nextButton, classNames)}
    onClick={onClick}
    ariaLabel={ariaLabel}
    testId="next-button"
  >
    <span className={styles.text}>{text}&nbsp;</span>
    <i className="icon-v2-chevron-right" aria-hidden />
  </OvalButton>
);
